// Central contact-details constants. Update once here — used everywhere the
// site references contact/phone/email. Registered office is deliberately NOT
// exported here: it lives in the footer only (user directive, 2026-07).

export const CONTACT = {
  phoneDisplay: '+44 (0)115 647 0600',
  phoneHref: 'tel:+441156470600',
  email: 'hello@thepadeldraw.co.uk',
  emailHref: 'mailto:hello@thepadeldraw.co.uk',
  postalAddressLines: ['The Padel Draw Ltd', '5 Brayford Square', 'London E1 0SG'],
  postalAddressInline: 'The Padel Draw Ltd, 5 Brayford Square, London, E1 0SG',
};

export default CONTACT;
